import { Card } from '@aimsos/ui';

/** Stat tile for workspace overview metrics (users, agents, workflows, campaigns). */
const WorkspaceOverviewStatCard = ({ label, value, hint, icon: Icon, iconClassName }) => (
  <Card className="flex min-h-0 w-full max-w-full min-w-0 flex-col gap-3 border-edge p-4">
    <div className="flex items-start justify-between gap-2">
      <span className="text-xs font-semibold uppercase tracking-wider text-content-muted">{label}</span>
      <div
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${iconClassName}`}
      >
        <Icon size={18} strokeWidth={2} />
      </div>
    </div>
    <div className="flex flex-col gap-0.5">
      <span className="text-2xl font-bold tabular-nums text-content">{value}</span>
      {hint ? <span className="text-xs text-content-muted">{hint}</span> : null}
    </div>
  </Card>
);

export default WorkspaceOverviewStatCard;
